import React from 'react';
import PropTypes from 'prop-types';
import { Badge, Button, Form } from 'react-bootstrap';

const NotesHeader = ({ notes, onExportNotes, notesYear, handleSetNotesYear }) => {
    return (
        <div className="notes-header">
            <h4>
                Notes
                <Badge variant="primary">{notes ? notes.length : 0}</Badge>
                <Form.Group controlId="surveyYear" className="mb-0 d-flex flex-column align-items-start">
                    <Form.Select
                        value={notesYear}
                        onChange={(e) => handleSetNotesYear(e.target.value)}
                        style={{ width: "6rem" }}
                    >
                        <option value={2026}>2026</option>
                        <option value={2025}>2025</option>
                    </Form.Select>
                </Form.Group>
                {notes?.length > 0 && (
                    <Button
                        title='Export notes to excel'
                        variant='primary'
                        disabled={notes?.length === 0}
                        onClick={onExportNotes}
                        className="ms-2 px-2"
                    >
                        <i className="fa fa-file-csv" style={{ fontSize: '1.2rem', padding: "0 0.5rem" }}></i>
                    </Button>
                )}
            </h4>
        </div>
    );
};

NotesHeader.propTypes = {
    notes: PropTypes.array.isRequired,
    onExportNotes: PropTypes.func.isRequired
};

export default NotesHeader; 